import { useState } from "react";
import Navbar from "../../components/Navbar/Navbar";

import "./Analytics.css";

function Analytics() {
  const [media, setMedia] = useState("");

  return (
    <div className="analytic">
      <Navbar/>
      <div className="info">
        <form className="ana-social">
          <select
            value={media}
            onChange={(e) => {
              setMedia(e.target.value);
            }}
            name="media"
          >
            <option value="sermon">Sermon</option>
            <option value="bibleStudy">Bible Study</option>
            <option value="sundaySchool">Sunday School</option>
          </select>
        </form>
        <hr />
        {media === "sermon" ? (
          <sermons />
        ) : media === "bibleStudy" ? (
          <bibleStudy />
        ) : (
          <sermons />
        )}
      </div>
    </div>
  );
}

export default Analytics;
